import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useCustomerAuth } from "../context/CustomerAuthContext";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";

export default function CustomerLogin() {
  const { lang } = useApp();
  const { customer, login } = useCustomerAuth();
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (customer) return <Navigate to="/customer" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(loginId, password);
      toast.success(lang === "en" ? "Welcome back" : "మరల స్వాగతం");
      navigate("/customer");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="customer-login-page" className="bg-[#fbf8f1] min-h-[80vh] grid place-items-center px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-stone-200 rounded-sm p-8">
        <div className="text-[11px] tracking-[0.2em] uppercase text-[#b45f06] font-semibold mb-2">
          {lang === "en" ? "Wholesale Portal" : "హోల్‌సేల్ పోర్టల్"}
        </div>
        <h1 className="text-2xl font-semibold text-stone-900">
          {lang === "en" ? "Customer Login" : "కస్టమర్ లాగిన్"}
        </h1>
        <div className="mt-6 space-y-4">
          <Field label="Login ID" value={loginId} onChange={setLoginId} testId="cust-login-id" />
          <Field label="Password" type="password" value={password} onChange={setPassword} testId="cust-login-password" />
          <button
            data-testid="cust-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#274e13] hover:bg-[#38761d] text-white py-3 rounded-sm font-semibold tracking-wide transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : (lang === "en" ? "Sign in" : "సైన్ ఇన్")}
          </button>
          <div className="text-sm text-stone-600 text-center">
            {lang === "en" ? "New here?" : "కొత్తవారా?"}{" "}
            <Link to="/customer/register" className="text-[#274e13] font-semibold hover:underline">
              {lang === "en" ? "Register your business" : "మీ వ్యాపారం నమోదు చేయండి"}
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testId }) {
  return (
    <div>
      <label className="text-xs tracking-wider uppercase text-stone-500 font-semibold">{label}</label>
      <input
        data-testid={testId}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        className="mt-1 w-full bg-[#fafaf9] border border-stone-300 rounded-sm px-3 py-2.5 focus:outline-none focus:border-[#274e13]"
      />
    </div>
  );
}
